import React from "react";
import PenIcon from "_c/icon/Pencil";
import CheckmarkIcon from "_c/icon/Checkmark";
import DenyIcon from "_c/icon/Deny";
import { MASTER_CLIENTS_NS as ns } from "@/i18n/ns";
import Tooltip from "_c/Tooltip";
import type { tBizClient } from "@/types";
import type { TFunction } from "i18next";
import { useCurrency } from "@/hooks/useCurrency";
import { CurrencyFormatter } from "@/i18n/currency";
import isNil from "lodash/isNil";

type tProps = {
  client: tBizClient;
  className?: string;
  t: TFunction;
};
const Stats = ({ client: { stats }, t, className }: tProps) => {
  const currency = useCurrency();
  if (!stats) return null;
  return (
    <div
      style={{
        display: "flex",
        alignItems: "flex-start",
      }}
      className={className}
    >
      <Chip
        color="var(--color-primary)"
        icon={<PenIcon width="11" />}
        count={stats.tasks_count}
        title={t(`${ns}:count_orders`)}
      />
      <Chip
        color="var(--color-cta)"
        icon={<CheckmarkIcon width="10" color="white" />}
        count={stats.completed_tasks_count}
        title={t(`${ns}:completed_orders`)}
      />
      <Chip
        color="var(--color-danger)"
        icon={<DenyIcon width="8" color="white" />}
        count={stats.cancelled_tasks_count}
        title={t(`${ns}:cancelled_orders`)}
      />
      {!isNil(stats.tasks_income) && stats.tasks_income > 0 && (
        <Chip
          color="var(--color-cta)"
          icon={<span>$</span>}
          count={
            CurrencyFormatter.format({
              amount: Math.max(0, stats.tasks_income),
              currency,
            })!
          }
          title={t(`${ns}:orders_income`)}
        />
      )}
    </div>
  );
};

const Chip = ({
  icon,
  count,
  color,
  title,
}: {
  icon: any;
  color: string;
  count?: number | string;
  title: string;
}) => {
  return (
    <Tooltip title={title}>
      <div
        css={`
          display: flex;
          justify-content: flex-start;
          align-items: center;
          height: 26px;
          margin-inline-end: 5px;
          border-radius: 24px;
          padding: 5px 10px;
          color: white;
          font-size: 14px;
          font-weight: 500;
          user-select: none;
          line-height: 0;
        `}
        style={{
          backgroundColor: color,
        }}
      >
        {icon}
        <span
          css={`
            margin-inline-start: 8px;
          `}
        >
          {count}
        </span>
      </div>
    </Tooltip>
  );
};

export default Stats;
